<style lang="scss">
	.portal-app {
		--portal-rail-expanded: 252px;
		--portal-rail-collapsed: 80px;
		--portal-header-height: 64px;
		--portal-canvas: var(--v-canvas-base);
		--portal-surface: var(--v-white-base);
		--portal-border: var(--v-gray_30-base);
		--portal-text: var(--v-gray_90-base);
		--portal-muted: var(--v-gray_70-base);
		--portal-nav-text: var(--v-sidebar_text-base);
		--portal-nav-muted: color-mix(in srgb, var(--portal-nav-text) 74%, transparent);
		--portal-nav-border: color-mix(in srgb, var(--portal-nav-text) 16%, transparent);
		--portal-radius-sm: 10px;
		--portal-radius-md: 16px;
		text-align: left;
	}

	.portal-app.portal-brand-kit {
		--portal-table-row-hover: color-mix(in srgb, var(--brand-primary) 5%, var(--portal-table-row-background));
		--portal-canvas: var(--brand-background);
		--portal-surface: var(--brand-surface);
		--portal-border: var(--brand-border);
		--portal-text: var(--brand-surfaceText);
		--portal-muted: var(--brand-surfaceMuted);
		--portal-radius-sm: var(--brand-field-radius);
		--portal-radius-md: var(--brand-surface-radius, 16px);
		font-family: var(--brand-body-family), sans-serif;
		font-size: var(--brand-body-size);
		font-weight: var(--brand-body-weight);
		color: var(--brand-body-color);
	}

	@each $level in h1, h2, h3 {
		.portal-app.portal-brand-kit #{$level}:not(.invoice-document *) {
			font-family: var(--brand-#{$level}-family), sans-serif;
			font-size: var(--brand-#{$level}-size);
			font-weight: var(--brand-#{$level}-weight);
			color: var(--brand-#{$level}-color);
		}
	}

	.portal-app.portal-brand-kit button:not(.invoice-document *):focus-visible,
	.portal-app.portal-brand-kit a:not(.invoice-document *):focus-visible {
		outline-color: var(--brand-state-focusRing);
	}

	.portal-app.portal-brand-kit .v-dialog:not(.v-dialog--fullscreen):not(.task-right-modal) {
		border-radius: var(--brand-surface-radius);
	}

	.portal-app.portal-brand-kit button.dialog-close:not(.invoice-document *) {
		border-radius: var(--brand-button-radius);
	}

	.portal-app.portal-brand-kit button.v-btn:not(.invoice-document *):not(.v-btn--icon) {
		border-radius: var(--brand-button-radius) !important;
		font-family: var(--brand-button-family), sans-serif;
		font-size: var(--brand-button-size);
		font-weight: var(--brand-button-weight);
		letter-spacing: var(--brand-button-letterSpacing);
	}

	.portal-app.portal-brand-kit button.v-btn:not(.invoice-document *):is(.primary, .super-action):not(.v-btn--text),
	.portal-app.portal-brand-kit button.v-btn:not(.invoice-document *):is(.primary-action, .secondary-action):not(.v-btn--text) {
		border: var(--brand-button-borderWidth) solid var(--brand-button-border) !important;
	}

	.portal-app.portal-brand-kit button.v-btn:not(.invoice-document *):is(.primary, .super-action):not(.v-btn--text) {
		background: var(--brand-button-fill) !important;
		color: var(--brand-button-solidText) !important;
	}

	.portal-app.portal-brand-kit button.v-btn:not(.invoice-document *):is(.primary-action, .secondary-action) {
		border-color: var(--brand-button-secondaryBorder) !important;
		background: var(--brand-button-secondaryBackground) !important;
		color: var(--brand-button-secondaryText) !important;
	}

	.portal-app.portal-brand-kit.brand-button-outline button.v-btn:not(.invoice-document *):is(.primary, .super-action),
	.portal-app.portal-brand-kit.brand-button-text button.v-btn:not(.invoice-document *):is(.primary, .super-action) {
		background: transparent !important;
		color: var(--brand-button-text) !important;
	}

	.portal-app.portal-brand-kit.brand-button-text button.v-btn:not(.invoice-document *):is(.primary, .super-action),
	.portal-app.portal-brand-kit.brand-secondary-text button.v-btn:not(.invoice-document *):is(.primary-action, .secondary-action) {
		border-color: transparent !important;
	}

	.portal-app.portal-brand-kit button.v-btn:not(.invoice-document *):is(.primary, .super-action, .primary-action, .secondary-action):not(:disabled):hover {
		background: var(--brand-state-hoverBackground) !important;
		color: var(--brand-state-hoverText) !important;
	}

	.portal-app.portal-brand-kit button:not(.invoice-document *):is(
			.dialog-action,
			.connection-action,
			.portal-button,
			.reschedule-action,
			.done-action,
			.add-comment-action,
			.manage-subscriptions,
			.submit-request-action,
			.new-request-action,
			.pay-action,
			.save-action,
			.primary-payment-action,
			.secondary-payment-action,
			.file-upload-action
		) {
		border-radius: var(--brand-button-radius) !important;
		font-family: var(--brand-button-family), sans-serif !important;
		font-size: var(--brand-button-size) !important;
		font-weight: var(--brand-button-weight) !important;
		letter-spacing: var(--brand-button-letterSpacing) !important;
	}

	.portal-app.portal-brand-kit button:not(.invoice-document *):is(
			.dialog-action.primary,
			.connection-action.primary,
			.portal-button.primary,
			.reschedule-action,
			.done-action,
			.add-comment-action,
			.manage-subscriptions,
			.submit-request-action,
			.new-request-action,
			.pay-action,
			.save-action,
			.primary-payment-action
		) {
		border: var(--brand-button-borderWidth) solid var(--brand-button-border) !important;
		background: var(--brand-button-fill) !important;
		color: var(--brand-button-solidText) !important;
	}

	.portal-app.portal-brand-kit button:not(.invoice-document *):is(
			.dialog-action.outline,
			.connection-action.outline,
			.portal-button.outline,
			.secondary-payment-action,
			.file-upload-action
		) {
		border: var(--brand-button-borderWidth) solid var(--brand-button-border) !important;
		border-color: var(--brand-button-secondaryBorder) !important;
		background: var(--brand-button-secondaryBackground) !important;
		color: var(--brand-button-secondaryText) !important;
	}

	.portal-app.portal-brand-kit.brand-button-outline button:not(.invoice-document *):is(
			.dialog-action.primary,
			.connection-action.primary,
			.portal-button.primary,
			.reschedule-action,
			.done-action,
			.add-comment-action,
			.manage-subscriptions,
			.submit-request-action,
			.new-request-action,
			.pay-action,
			.save-action,
			.primary-payment-action
		),
	.portal-app.portal-brand-kit.brand-button-text button:not(.invoice-document *):is(
			.dialog-action.primary,
			.connection-action.primary,
			.portal-button.primary,
			.reschedule-action,
			.done-action,
			.add-comment-action,
			.manage-subscriptions,
			.submit-request-action,
			.new-request-action,
			.pay-action,
			.save-action,
			.primary-payment-action
		) {
		background: transparent !important;
		color: var(--brand-button-text) !important;
	}

	.portal-app.portal-brand-kit.brand-button-text button:not(.invoice-document *):is(
			.dialog-action.primary,
			.connection-action.primary,
			.portal-button.primary,
			.reschedule-action,
			.done-action,
			.add-comment-action,
			.manage-subscriptions,
			.submit-request-action,
			.new-request-action,
			.pay-action,
			.save-action,
			.primary-payment-action
		),
	.portal-app.portal-brand-kit.brand-secondary-text button:not(.invoice-document *):is(
			.dialog-action.outline,
			.connection-action.outline,
			.portal-button.outline,
			.secondary-payment-action,
			.file-upload-action
		) {
		border-color: transparent !important;
	}

	.portal-app.portal-brand-kit button:not(.invoice-document *):is(
			.dialog-action,
			.connection-action,
			.portal-button,
			.reschedule-action,
			.done-action,
			.add-comment-action,
			.manage-subscriptions,
			.submit-request-action,
			.new-request-action,
			.pay-action,
			.save-action,
			.primary-payment-action,
			.secondary-payment-action,
			.file-upload-action
		):not(:disabled):hover {
		background: var(--brand-state-hoverBackground) !important;
		color: var(--brand-state-hoverText) !important;
	}

	.portal-app.portal-brand-kit button.v-btn:not(.invoice-document *):disabled {
		background: var(--brand-state-disabledBackground) !important;
		color: var(--brand-state-disabledText) !important;
		opacity: var(--brand-disabled-opacity);
	}

	.portal-app.portal-brand-kit .v-text-field:not(.invoice-document *) > .v-input__control > .v-input__slot {
		border-radius: var(--brand-field-radius) !important;
		background: var(--brand-field-fill) !important;
		box-shadow: var(--brand-field-shadow) !important;
		color: var(--brand-surfaceFieldAnswer);
	}

	.portal-app.portal-brand-kit .v-text-field:not(.invoice-document *):not(.v-input--is-focused):not(.error--text) fieldset {
		border-width: var(--brand-field-borderWidth);
		border-color: var(--brand-field-border);
	}

	.portal-app.portal-brand-kit .v-text-field.v-input--is-focused:not(.invoice-document *) > .v-input__control > .v-input__slot {
		box-shadow: 0 0 0 var(--brand-state-focusRingWidth) var(--brand-state-focusRingShadow) !important;
	}

	.portal-app.portal-brand-kit .v-text-field.v-input--is-focused:not(.invoice-document *) fieldset {
		border-color: var(--brand-state-focusBorder) !important;
	}

	.portal-app.portal-brand-kit .v-text-field.error--text:not(.invoice-document *) fieldset {
		border-color: var(--brand-state-errorBorder) !important;
	}

	.portal-app.portal-brand-kit .v-text-field.error--text:not(.invoice-document *),
	.portal-app.portal-brand-kit .v-messages.error--text:not(.invoice-document *) {
		color: var(--brand-state-errorText) !important;
	}

	.portal-app.portal-brand-kit .v-text-field:not(.invoice-document *) input,
	.portal-app.portal-brand-kit .v-text-field:not(.invoice-document *) textarea,
	.portal-app.portal-brand-kit .v-select__selection:not(.invoice-document *) {
		font-family: var(--brand-answer-family), sans-serif;
		font-size: var(--brand-answer-size);
		font-weight: var(--brand-answer-weight);
		color: var(--brand-surfaceFieldAnswer) !important;
	}

	.portal-app.portal-brand-kit .v-text-field:not(.invoice-document *) input::placeholder,
	.portal-app.portal-brand-kit .v-text-field:not(.invoice-document *) textarea::placeholder {
		color: var(--brand-surfaceFieldPlaceholder) !important;
		opacity: 1;
	}

	.portal-app.portal-brand-kit .v-label:not(.invoice-document *) {
		font-family: var(--brand-label-family), sans-serif;
		font-size: var(--brand-label-size);
		font-weight: var(--brand-label-weight);
		color: var(--brand-label-color);
	}

	.portal-app.portal-brand-kit .v-menu__content:not(.mx-brand-form-menu) {
		border-radius: var(--brand-surface-radius);
	}

	.portal-app.portal-brand-kit .v-menu__content:not(.mx-brand-form-menu),
	.portal-app.portal-brand-kit .v-menu__content:not(.mx-brand-form-menu) .v-list {
		border-color: var(--brand-border);
		background: var(--brand-surface);
		color: var(--brand-surfaceText);
	}

	.portal-app.portal-brand-kit .v-menu__content:not(.mx-brand-form-menu) .v-list-item {
		color: var(--brand-surfaceText);
	}

	.portal-app.portal-brand-kit .v-menu__content:not(.mx-brand-form-menu) .v-list-item--active {
		background: color-mix(in srgb, var(--brand-primary) 10%, var(--brand-surface));
		color: var(--brand-primary);
	}

	.portal-app.portal-brand-kit .login-card,
	.portal-app.portal-brand-kit .login-method {
		border-color: var(--brand-border);
		background: var(--brand-surface);
		color: var(--brand-surfaceText);
	}

	.portal-app.portal-brand-kit .login-method {
		border-radius: var(--brand-button-radius);
		font-family: var(--brand-button-family), sans-serif;
		font-size: var(--brand-button-size);
		font-weight: var(--brand-button-weight);
	}

	.portal-app.portal-brand-kit .login-greeting,
	.portal-app.portal-brand-kit .login-greeting h1,
	.portal-app.portal-brand-kit .login-greeting h2,
	.portal-app.portal-brand-kit .login-greeting h3 {
		color: var(--brand-surfaceText);
	}

	.portal-frame {
		width: 100%;
		height: var(--vh);
		min-height: 0;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		background: var(--portal-canvas);
		color: var(--portal-text);
	}

	.portal-workspace {
		min-height: 0;
		flex: 1;
		display: flex;
		overflow: visible;
	}

	#left-nav {
		flex: 0 0 var(--v-left-nav-width);
		width: var(--v-left-nav-width);
		min-width: var(--v-left-nav-width);
		border-right: 1px solid var(--portal-nav-border);
		background-color: var(--v-sidebar-base);
		color: var(--portal-nav-text);
		transition: width 180ms ease, min-width 180ms ease, flex-basis 180ms ease;
	}

	#right-section {
		min-width: 0;
		min-height: 0;
		flex: 1;
		display: flex;
	}

	#right-bar {
		min-width: var(--v-right-nav-width);
		max-width: var(--v-right-nav-width);
		width: var(--v-right-nav-width);
		min-height: 0;
		display: flex;
		overflow: hidden;
		transition: width 200ms ease, min-width 200ms ease, max-width 200ms ease;
		background-color: var(--portal-surface);
		border-left: 1px solid var(--portal-border);
	}

	#main-content {
		min-width: 0;
		min-height: 0;
		flex: 1;
		overflow: auto;
		background-color: var(--portal-canvas);
		scrollbar-gutter: stable;
	}

	#main-content.is-full-bleed,
	#main-content.is-full-bleed .v-main,
	#main-content.is-full-bleed .v-main__wrap {
		height: 100%;
		padding: 0;
		border: 0;
	}

	#main-app {
		min-width: 0;
		min-height: 0;
		flex: 1;
		display: flex;
		overflow: hidden;
		background-color: var(--portal-canvas);
	}

	#main-content .v-data-table {
		border: 1px solid var(--portal-border);
		border-radius: var(--portal-radius-md);
		background: var(--portal-table-row-background, var(--portal-surface));
		box-shadow: none;
		overflow: hidden;
	}

	#main-content .v-data-table > .v-data-table__wrapper > table > thead > tr > th {
		height: 44px;
		background: var(--brand-surface, var(--v-gray_20-base));
		color: var(--portal-muted);
		font-size: 12px;
		font-weight: 650;
		letter-spacing: 0.02em;
	}

	#main-content .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
		height: 52px;
		border-color: var(--portal-border);
		color: var(--portal-table-row-text, var(--portal-text));
	}

	#main-content .v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
		background: var(--v-gray_10-base);
	}

	.portal-app.portal-brand-kit #main-content .v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
		background: var(--portal-table-row-hover);
	}

	.portal-app.portal-brand-kit #main-content .v-data-table > .v-data-footer {
		background: var(--portal-surface);
		color: var(--portal-text);
	}

	#main-content .portal-compact-list-shell {
		container: portal-compact-list / inline-size;
	}

	#main-content .portal-compact-table > .v-data-table__wrapper > table {
		width: 100%;
		table-layout: fixed;
	}

	#main-content .portal-compact-table > .v-data-table__wrapper > table > thead > tr > th,
	#main-content .portal-compact-table > .v-data-table__wrapper > table > tbody > tr > td {
		min-width: 0;
		padding-right: 12px;
		padding-left: 12px;
		white-space: nowrap;
	}

	#main-content .portal-compact-table > .v-data-table__wrapper > table > tbody > tr > td {
		height: 48px;
		overflow: hidden;
		color: var(--portal-table-row-text, var(--portal-text));
		font-size: 13px;
		text-overflow: ellipsis;
	}

	#main-content .portal-cell-truncate {
		min-width: 0;
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	#main-content .portal-cell-primary {
		font-weight: 620;
	}

	#main-content .portal-cell-muted {
		color: var(--portal-table-row-muted, var(--portal-muted));
	}

	@container portal-compact-list (max-width: 880px) {
		#main-content .portal-compact-table > .v-data-table__wrapper > table {
			table-layout: auto;
		}

		#main-content .portal-list-priority-low {
			display: none;
		}

		#main-content .portal-list-grow {
			width: 100% !important;
			max-width: 0;
		}
	}

	@container portal-compact-list (max-width: 680px) {
		#main-content .portal-list-priority-medium {
			display: none;
		}
	}

	@container portal-compact-list (max-width: 520px) {
		#main-content .portal-list-priority-compact {
			display: none;
		}
	}

	#main-content .v-input {
		font-size: 14px;
	}

	:root {
		--v-recaptcha-visibility: visible;
	}

	.grecaptcha-badge {
		visibility: var(--v-recaptcha-visibility) !important;
	}

	@media (max-width: 599px) {
		.intercom-lightweight-app-launcher {
			bottom: 82px !important;
		}

		.portal-mobile-menu-open .intercom-lightweight-app-launcher {
			display: none !important;
		}
	}
</style>

<template>
	<v-app
		data-app
		class="portal-app"
		:class="portalBrandClasses"
		:style="appStyle"
		v-if="isReady"
	>
		<div
			class="portal-frame"
			v-if="$store.state.isLoggedIn"
			:style="`--v-right-nav-width:${rightNavWidth}; --v-left-nav-width:${leftNavWidth};`"
		>
			<top-nav></top-nav>
			<div class="portal-workspace">
				<aside id="left-nav" class="d-none d-sm-flex" :aria-label="$t('nav.portal-navigation')">
					<left-nav></left-nav>
				</aside>
				<div id="right-section">
					<div id="main-app">
						<main id="main-content" :class="{ 'is-full-bleed': $route.meta.fullBleed }">
							<v-main>
								<router-view />
							</v-main>
						</main>
						<aside id="right-bar" v-show="!mobile" :aria-label="$t('nav.notifications')">
							<right-nav></right-nav>
						</aside>
					</div>
				</div>
			</div>
			<mobile-nav class="d-flex d-sm-none"></mobile-nav>
		</div>
		<div v-else style="height: 100%">
			<router-view></router-view>
		</div>
		<v-snackbar id="main-snackbar" v-model="show" :color="color" :timeout="timeout" :top="true" style="font-size: 1.1em">
			<div>{{ message }}</div>
			<v-btn dark icon @click="show = false" id="main-snackbar-close">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
		<v-overlay style="z-index: 1000" :value="$store.state.loadingState">
			<div class="loading-status" role="status" aria-live="polite">
				<v-progress-circular indeterminate size="64"></v-progress-circular>
				<div v-if="$store.state.loadingMessage">{{ $store.state.loadingMessage }}</div>
			</div>
		</v-overlay>
		<global-modal-controller ref="gmc"></global-modal-controller>
	</v-app>
</template>

<script>
	import { readStorage } from '@/utils/safeStorage';
	import AuthService from '@/modules/auth/AuthService';
	import WebFontLoader from 'webfontloader';
	import LeftNav from '@/views/nav/LeftNav.vue';
	import RightNav from '@/views/nav/RightNav';
	import GlobalModalController from '@/modules/utils/GlobalModalController';
	//import NotificationStateManager from '@/modules/productivity/notifications/NotificationStateManager';
	import CustomFontService from '@/modules/utils/CustomFontService';
	import { Settings as LuxonSettings } from 'luxon';
	import TopNav from '@/views/nav/TopNav.vue';
	import MobileNav from '@/views/nav/MobileNav.vue';
	import { readableTextColor } from '@/utils/colorContrast';
	import { applyPortalFavicon, documentBrandAppearance, portalBrandClasses, portalBrandingActive, portalBrandStyle, portalFont, portalGoogleFontFamilies, preferredBrandAppearance, resolveAppearanceBranding, resolvePortalBranding } from '@/utils/portalBranding';
	import { brandTextColor, resolveBrandAppearance } from '@moxie/branding';
	import themes from '@/assets/css/themes';

	export default {
		name: 'App',
		components: {
			TopNav,
			MobileNav,
			LeftNav,
			RightNav,
			GlobalModalController,
		},

		data() {
			return {
				mobile: true,
				windowWidth: null,
				show: false,
				message: null,
				timeout: -1,
				color: 'success',
				isReady: false,
				showFullApp: false,
				primaryFont: null,
				timeouts: { error: 0, warning: 10, info: 7, success: 7 },
			};
		},

		created() {
			window.addEventListener('resize', this.checkScreen);
			this.checkScreen();
		},

		mounted() {
			if (navigator.languages && navigator.languages.length) {
				this.$store.state.locale = navigator.languages[0];
				console.log('Setting locale to ' + this.$store.state.locale);
			}

			let selectedClientId = readStorage('SELECTED_CLIENT');
			if (selectedClientId) {
				this.$store.state.selectedClientId = selectedClientId;
			}

			let domain;

			if (document.location.hostname === 'localhost' || document.location.host === 'hectic.ngrok.io') {
				// Local/ngrok dev only. Override per developer with VUE_APP_PORTAL_DOMAIN in
				// .env.development.local (gitignored) rather than editing this file.
				domain = process.env.VUE_APP_PORTAL_DOMAIN || 'clients1.geoffreymina.com';
			} else {
				domain = document.location.host;
			}

			AuthService.getDomainSettings(domain)
				.then((res) => {
					if (res) {
						this.$store.commit('setDomain', res);
					}
					this.initLocale();
					this.initBranding();
					this.initDarkMode();
					this.initFonts();
				})
				.catch((err) => {
					console.log('Error loading branding', err);
					this.initBranding();
				});

			this.setMaxVh();
			window.addEventListener('resize', () => {
				this.setMaxVh();
			});
		},

		methods: {
			setMaxVh: function() {
				let vh = window.innerHeight;
				document.documentElement.style.setProperty('--vh', `${vh}px`);
			},

			initLocale: function() {
				let availableLocales = this.$i18n.availableLocales;
				let usersLanguage = window.navigator.language;
				if (readStorage('lang')) {
					this.$i18n.locale = readStorage('lang');
				} else if (availableLocales.includes(usersLanguage)) {
					this.$i18n.locale = usersLanguage;
				} else {
					this.$i18n.locale = 'en';
				}

				LuxonSettings.defaultLocale = navigator.languages[0];
				console.log(LuxonSettings.defaultLocale);
			},

			initBranding: function() {
				for (const theme of ['light', 'dark']) {
					const defaults = themes[theme];
					Object.assign(this.$vuetify.theme.themes[theme], {
						primary: defaults.primary,
						accent: defaults.accent,
						canvas: defaults.canvas,
						sidebar: defaults.sidebar,
						sidebar_text: defaults.sidebar_text,
					});
				}
				if (this.portalBranding) {
					for (const theme of ['light', 'dark']) {
						const branding = resolvePortalBranding(this.$store.state.domain, theme);
						this.$vuetify.theme.themes[theme].primary = branding.buttons.fill;
						this.$vuetify.theme.themes[theme].accent = branding.colors.accent;
						this.$vuetify.theme.themes[theme].canvas = branding.colors.background;
						this.$vuetify.theme.themes[theme].sidebar = branding.colors.primary;
						this.$vuetify.theme.themes[theme].sidebar_text = brandTextColor(branding, branding.colors.text, branding.colors.primary);
					}
					document.title = this.$store.state.domain.accountName;
				} else if (this.$store.state.domain && this.$store.state.domain.customBranding) {
					let branding = this.$store.state.domain.customBranding;
					this.$vuetify.theme.themes.light.primary = branding.primaryColor;
					if (branding.navColor) {
						this.$vuetify.theme.themes.light.sidebar = branding.navColor;
						this.$vuetify.theme.themes.light.sidebar_text = readableTextColor(branding.navColor);
					}

          if(branding.primaryColorDark){
            this.$vuetify.theme.themes.dark.primary = branding.primaryColorDark
          }

          if(branding.navColorDark){
            this.$vuetify.theme.themes.dark.sidebar = branding.navColorDark;
						this.$vuetify.theme.themes.dark.sidebar_text = readableTextColor(branding.navColorDark);
          }

					document.title = this.$store.state.domain.accountName;

				} else {
					console.log('applying default branding');
				}
				applyPortalFavicon(this.$store.state.domain, this.portalBranding && this.portalBranding.colors.background);
				this.isReady = true;
			},

			initFonts: function() {
				if (this.$store.state.domain) {
					let customFontService = new CustomFontService(this.$store.state.domain.podUrl);
					customFontService.getCustomFonts(this.$store.state.domain.accountId).then((res) => {
						if (res.data && res.data.length) {
							this.$store.state.accountFonts.push(...res.data);
							this.loadCustomFonts(res.data);
						} else {
							this.loadGoogleFont();
						}
					});
				}
			},

			loadCustomFonts: function(fonts) {
				let p = [];

				for (let i = 0; i < fonts.length; i++) {
					let font = fonts[i];
					let newFont = new FontFace(font.fontName, `url(${font.fontUrl})`);
					p.push(newFont.load());
				}

				Promise.all(p)
					.then((loadedFonts) => {
						for (let i = 0; i < loadedFonts.length; i++) {
							console.log('loaded font', loadedFonts[i]);
							document.fonts.add(loadedFonts[i]);
						}
					})
					.finally(() => (this.portalBranding ? this.loadGoogleFont() : this.setFont()));
			},

			loadGoogleFont: function() {
				if (this.portalBranding) {
					const families = portalGoogleFontFamilies(this.portalBranding, this.$store.state.accountFonts);
					if (!families.length) return this.setFont();
					WebFontLoader.load({
						google: {
							families: families.map((font) => `${font}:200,300,400,500,600,700`),
						},
						active: this.setFont,
					});
				} else if (this.$store.state.domain && this.$store.state.domain.customBranding) {
					let branding = this.$store.state.domain.customBranding;
					WebFontLoader.load({
						google: {
							families: [`${branding.font}:200,300,400,500,600`],
						},
						active: this.setFont,
					});
				}
			},

			setFont: function() {
				this.primaryFont = portalFont(this.portalBranding, this.$store.state.domain.customBranding);
				document.documentElement.style.setProperty('--primary-font', this.primaryFont);
			},

			initDarkMode() {
				this.darkMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
				let darkModePref = readStorage('DARK_MODE');
				this.$store.state.eventBus.$on('dark-mode-changed', this.updateDarkMode);
				this.$store.state.eventBus.$on('document-branding-changed', this.updateDarkMode);

				if (darkModePref) {
					this.$store.state.darkMode = darkModePref;
				} else if (
					this.$store.state.domain &&
					this.$store.state.domain.customBranding &&
					this.$store.state.domain.customBranding.darkMode
				) {
					this.$store.state.darkMode = this.$store.state.domain.customBranding.darkMode.toLowerCase();
				}

				this.updateDarkMode(this.$store.state.darkMode);
			},

			updateDarkMode: function(darkModePref) {
				const preference = ['automatic', 'never', 'always'].includes(darkModePref)
					? darkModePref
					: this.$store.state.darkMode;
				const preferred = preferredBrandAppearance(preference, this.darkMediaQuery.matches);
				const documentBranding = this.$store.state.documentBranding;
				const documentActive = documentBranding !== null;
				if (!documentActive) this.initBranding();
				const appearanceBranding = documentBranding === false
					? null
					: documentBranding || (this.$store.state.domain && this.$store.state.domain.defaultBranding);
				const appearance = documentActive
					? documentBrandAppearance(documentBranding, preferred)
					: appearanceBranding ? resolveBrandAppearance(appearanceBranding, preferred) : preferred;

				if (preference === 'automatic') {
					this.enableAutomaticDarkMode();
				} else {
					this.disableAutomaticDarkMode();
				}
				this.$vuetify.theme.dark = appearance === 'dark';
				if (appearanceBranding) {
					const branding = resolveAppearanceBranding(appearanceBranding, appearance);
					const theme = this.$vuetify.theme.themes[appearance];
					theme.primary = branding.buttons.fill;
					theme.accent = branding.colors.accent;
					theme.canvas = branding.colors.background;
					theme.sidebar = branding.colors.primary;
					theme.sidebar_text = brandTextColor(branding, branding.colors.text, branding.colors.primary);
				}
			},

			enableAutomaticDarkMode: function() {
				this.darkMediaQuery.addEventListener('change', this.toggleDarkMode);
			},

			disableAutomaticDarkMode: function() {
				this.darkMediaQuery.removeEventListener('change', this.toggleDarkMode);
			},

			toggleDarkMode() {
				this.updateDarkMode(this.$store.state.darkMode);
			},

			checkScreen() {
				this.windowWidth = window.innerWidth;
				if (this.windowWidth <= 599) {
					this.mobile = true;
					return;
				}
				this.mobile = false;
				this.mobileNav = false;
			},
		},

		computed: {
			portalBranding() {
				return resolvePortalBranding(this.$store.state.domain, this.$vuetify.theme.dark ? 'dark' : 'light');
			},

			portalBrandKitActive() {
				return portalBrandingActive(this.portalBranding, this.$route);
			},

			portalBrandClasses() {
				return portalBrandClasses(this.portalBrandKitActive ? this.portalBranding : null);
			},

			appStyle() {
				return {
					...portalBrandStyle(this.portalBrandKitActive ? this.portalBranding : null),
					'--primary-font': this.portalBrandKitActive
						? this.primaryFont || this.portalBranding.typography.bodyFamily
						: portalFont(null, this.$store.state.domain && this.$store.state.domain.customBranding),
					height: '100%',
				};
			},

			alert() {
				return this.$store.state.alert;
			},

			customEmbed: function() {
				return this.$store.state.customEmbed;
			},

			leftNavWidth: function() {
				if (this.$vuetify.breakpoint.xsOnly) {
					return '0px';
				} else {
					return this.$store.state.leftNavExpanded
						? 'var(--portal-rail-expanded)'
						: 'var(--portal-rail-collapsed)';
				}
			},

			rightNavWidth: function() {
				return this.$store.state.rightNavExpanded ? '300px' : '0px';
			},

			notificationWindow: {
				get: function() {
					return this.$store.state.notificationWindowOpenState;
				},

				set: function(val) {
					this.$store.commit('notificationWindow', val);
				},
			},
		},

		watch: {
			'$vuetify.theme.dark'() {
				applyPortalFavicon(this.$store.state.domain, this.portalBranding && this.portalBranding.colors.background);
			},

			$route(to, from) {
				console.log('Route changed from ' + from.fullPath + ' to ' + to.fullPath);
				if (to.meta && to.meta.insecure) {
					this.showFullApp = false;
				} else {
					this.showFullApp = true;
				}
				if (this.isReady && this.$store.state.documentBranding === null) {
					this.updateDarkMode(this.$store.state.darkMode);
				}
			},

			customEmbed: function(val) {
				if (val) {
					let script_tag = document.createElement('script');
					script_tag.type = 'text/javascript';
					script_tag.text = val;
					document.body.appendChild(script_tag);
				}
			},

			alert(newAlert) {
				this.message = newAlert.message;
				this.color = newAlert.type;
				this.show = true;
				this.timeout = this.timeouts[newAlert.type] * 1000;
			},
		},
	};
</script>

<style lang="scss">
	@import './assets/css/fonts.css';
	@import './assets/css/vuetify.scss';
	@import './assets/css/brand.scss';
	@import './assets/css/svg.css';
	@import '~@moxie/branding/src/vue2-form.scss';

	.loading-status {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 16px;
		font-size: 16px;
		font-weight: 500;
	}

	#main-snackbar .v-snack__wrapper.v-sheet .v-snack__content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		div {
			flex: 1 1 auto;
			font-size: 16px;
		}
		#main-snackbar-close {
			flex: 0 0 32px;
			margin: 0;
			margin-right: -12px;
		}
	}
</style>
